(function(){
    'use strict';
    angular.module('app').controller('DriverGroupsController', DriverGroupsController);

    DriverGroupsController.$inject = ['$scope', 'FleetDriverGroupsTableService'];

    function DriverGroupsController($scope, FleetDriverGroupsTableService) {

        const vm = this;

        init();

        function init() {
            const paginationData = {
                size: 5,
                page: 0,
                sort: 'id'
            };
            getDriverGroups(paginationData);

        }

        function getDriverGroups() {
            vm.driverGroupsTableData = new FleetDriverGroupsTableService().tableData;
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/DriverGroupsController.js